import { render, staticRenderFns } from "./GoodsOrderRank.vue?vue&type=template&id=da95d5a0"
import script from "./GoodsOrderRank.vue?vue&type=script&lang=js"
export * from "./GoodsOrderRank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports